import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
//defined in .env file
import { CT_ORDER_URL, SERVICES_ORDER } from '../../env';


const ServiceList = () => {
    const { modules, invoice } = useSelector((state) => state.order);

    const [selected, updateSelected] = useState();
    const handleSelect = (template_service_id, service_id) => {
        if (service_id === 2) {
            window.open(CT_ORDER_URL, '_blank');
        }
        else {
            updateSelected(template_service_id);
        }
    }

    /** tile layout order configuration:
     *  - if SERVICES_ORDER provided (array of template_service_id), sort by that order first
     *  - remaining items sort by service_name ascending
     */
    const orderedRootModules = (() => {
        const roots = (modules || []).filter(item => !item.parent_template_service_id);
        if (!SERVICES_ORDER || SERVICES_ORDER.length === 0) {
            // No explicit order provided: keep original API order
            return roots;
        }
        // Normalize IDs to trimmed strings to avoid type mismatches between env (strings) and API data (numbers/strings)
        const keyOf = (id) => String(id).trim();
        const csvKeys = SERVICES_ORDER.map((id) => keyOf(id));
        const byKey = new Map(roots.map((item) => [keyOf(item.template_service_id), item]));
        const picked = new Set();
        const ordered = [];
        // First, add items in CSV order if present among roots
        for (const k of csvKeys) {
            if (byKey.has(k) && !picked.has(k)) {
                ordered.push(byKey.get(k));
                picked.add(k);
            }
        }
        // Then append remaining roots in their original API order
        for (const item of roots) {
            const k = keyOf(item.template_service_id);
            if (!picked.has(k)) {
                ordered.push(item);
            }
        }
        return ordered;
    })();

    // Dev-only debug: verify env order and resulting order in console
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.debug('SERVICES_ORDER:', SERVICES_ORDER, 'ordered ids:', orderedRootModules.map(m => m.template_service_id));
    }

    /**This is the place to customize order button in slideshow
     * orgType: Junior, High, College, Individual and default
     */
    const priceNote = (module) => {
        if (module !== null) {
            return (<div className='priceTag'>Order</div>);
        }
    }

    return (
        <div className="row g-3 services-tile-row">
            {orderedRootModules.map((module, index) => (
                <div key={`service-${index}-item`} className="col-12 col-sm-6 col-md-4 col-lg-3 services-tile-col">
                    <Link to={`/${invoice.url_key}/services/${module.template_service_id}`} onClick={() => {
                        handleSelect(module.template_service_id, module.service_id);
                        setTimeout(() => {
                            const element = document.getElementById('scroll-to');
                            if (element) element.scrollIntoView({ behavior: 'smooth' });
                        }, 50);
                    }}>
                        <div className={'card h-100 ' + (selected === module.template_service_id ? 'bg-light' : '')}>
                            {module.quantity > 0 && (
                                <div className="card-img-overlay">
                                    <div className="sr-only">Module is in shopping cart</div>
                                    <i className="fa fa-lg fa-shopping-cart text-success"></i>
                                </div>
                            )}
                            <div className="card-body d-flex flex-column justify-content-between">
                                <div className="card-image">
                                    <div className="row ms-0 me-0">
                                        <img src={module.service_logo_src} alt={`${module.service_name}`} title={module.service_name} />
                                    </div>
                                </div>
                                <div className="slideShowPriceNote">
                                    <div className="priceTag pt-1">
                                        {priceNote(module)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            ))}
        </div>


    )
}
export { ServiceList }